import { SecondaryHeader } from '@repo/ui/components/typography/Headers';
import { ModalContainer } from '../ui/ModalComponents';
import { Paragraph } from '@repo/ui/components/typography/Content';
import Icon from '@repo/ui/components/ui/Icon';

export default function MfaLoginModal({ options, onCancel }) {
  return (
    <ModalContainer>
      {options.mfaType === 'email' ? (
        <div style={{ textAlign: 'center' }}>
          <SecondaryHeader>Multi-Factor Authentication</SecondaryHeader>
          <Icon name="envelope-o" size="lg" />
          <Icon
            name="lock"
            size="lg"
            style={{ display: 'inline-block', transform: 'rotate(22deg)' }}
            color="goldenrod"
          />
          <Paragraph>
            Multi-factor authentication is enabled for your account, please check your email inbox
            for instructions to continue your sign in process.
          </Paragraph>
          <Paragraph style={{ fontStyle: 'italic' }}>
            If you do not receive an email from us within a few minutes, please check your spam
            folder or try signing in again to send another.{' '}
            <strong>
              The link you receive can only be used once, and will expire after 15 minutes.
            </strong>
          </Paragraph>
        </div>
      ) : (
        <Paragraph>Unsupported MFA Type</Paragraph>
      )}
    </ModalContainer>
  );
}
